import styled from 'styled-components';

export const StyledVisitTemplatesModalContent = styled.div`
   height: 490px;
`;
StyledVisitTemplatesModalContent.displayName = 'StyledVisitTemplatesModalContent';
